import React, { useEffect, useState } from "react"

import { ButtonProps } from "../../ts/interfaces"
import { getStripeId } from "../../utils/stripejs"
import { addItemToCart } from "../../checkout/events"
import { useCheckoutState, useCheckoutDispatch } from "../../checkout/state"
import { findProduct, useProducts } from "../../hooks/useProducts"
import { Product } from "../../checkout/product"
import { navigate } from "gatsby"

const CartButton = (props: ButtonProps) => {
  const { quantity } = props

  const checkoutState = useCheckoutState()
  const dispatch = useCheckoutDispatch()

  if (!props.link) {
    return <div>PRODUCT NOT FOUND</div>
  }

  const { product, addToCart, additionalProduct } = props.link[0]

  const stripeId = getStripeId(product?.stripeId, product?.stripeTestId)
  const strapiProducts = useProducts()
  const strapiProduct = findProduct(strapiProducts, stripeId)

  if (strapiProduct === null || strapiProduct === undefined || !product) {
    return <div>PRODUCT NOT FOUND</div>
  }

  let additionalP: Product | undefined | null
  if (additionalProduct) {
    additionalP = findProduct(
      strapiProducts,
      getStripeId(additionalProduct.stripeId, additionalProduct.stripeTestId)
    )
  }

  const handleClick = (event?: any) => {
    if (!addToCart) return

    if (props.onClick) {
      props.onClick()
    }

    addItemToCart(
      checkoutState,
      dispatch,
      quantity || 1,
      additionalP ? [strapiProduct, additionalP] : [strapiProduct], //the order is important
      strapiProducts
    )

    navigate("/store/checkout")
  }

  return (
    <>
      <span onClick={handleClick}>{props.children}</span>
    </>
  )
}

export default CartButton
